<div class="w-full min-h-[50vh] flex flex-col justify-center items-center">
	<h3 class="text-gray-700">Inscription au Dossier Patient</h3>
	<p class="my-4 text-sm text-gray-700">Veuillez saisir votre numéro de téléphone pour débuter votre inscription</p>

	<form [formGroup]="verifyPhoneNumberForm" (ngSubmit)="onSubmit()"
		class="w-full max-w-md flex flex-col items-center mt-7">
		<angular-phone-number-input [preferredCountries]="preferredCountries" [defaultCountry]="'SN'" [border]="true"
			formControlName="phoneNumber" (ngModelChange)="onPhoneInputChange($event)"
			class="w-[400px] h-[50px] rounded placeholder:text-gray-400 text-gray-700 bg-white border border-solid border-gray-300">
		</angular-phone-number-input>

		<button type="submit"
			class="bg-primary text-white py-3 px-4 rounded hover:bg-primary/90 transition-colors w-[400px] mt-4"
			[disabled]="loading">
			<span *ngIf="!loading" class="text-white">Recevoir un code</span>
			<span *ngIf="loading" class="text-white">Envoi en cours...</span>
		</button>
	</form>
</div>